import { useLocation } from '@reach/router'
import React from 'react'
import {
  FacebookShareButton,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  EmailShareButton,
  FacebookIcon,
  LinkedinIcon,
  TelegramIcon,
  WhatsappIcon,
  EmailIcon,
  TwitterIcon,
} from 'react-share'
import { connect } from 'react-redux'
import { makeShareUrl } from '@helpers/helper.rendering'
import { Development, Novelty, Property, RealEstateDataPageComponentData } from 'types'

const SocialModal = ({
  property,
  development,
  novelty,
  global_data,
}: {
  property?: Property | Development | null
  development?: Development | Property | null
  novelty?: Novelty
} & RealEstateDataPageComponentData) => {
  const API_KEY = global_data.pageConfig.keys.tokko

  const location = useLocation()

  const data = location?.href?.includes('novedad')
    ? novelty
    : location?.href?.includes('propiedad')
    ? property
    : development
  const url = location?.href

  const title =
    'Te comparto ' +
    (url?.includes('propiedad') ? 'la siguiente propiedad ' : '') +
    (url?.includes('emprendimiento') ? 'el siguiente emprendimiento: ' : '') +
    (url?.includes('venta') ? 'en venta: ' : '') +
    (url?.includes('temporario')
      ? 'en alquiler temporario: '
      : url?.includes('alquiler')
      ? 'en alquiler: '
      : '') +
    // (url?.includes("emprendimiento") ? getName(data) : (url?.includes("propiedad") ? getFakeAddres(data) + " " : '')) +
    (url?.includes('novedad') ? 'la siguiente novedad: ' : '')

  const formateMessage = (str: string) => {
    return encodeURIComponent(str)
      .replace(/[!'()]/g, escape)
      .replace(/\*/g, '%2A')
  }

  return data?.id ? (
    <div
      className="modal fade social-modal"
      id={'modal-social-' + data.id}
      //   tabindex="1066"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog modal-dialog-centered justify-content-center">
        <div className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title"
              id="staticBackdropLabel"
            >
              Compartilo en tus redes sociales
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body align-items-center d-flex justify-content-center">
            <div className="d-flex justify-content-center align-items-center">
              <a
                className="mx-1"
                href={
                  'https://api.whatsapp.com/send?text=' + title + formateMessage(url.toString())
                }
                target="_blank"
              >
                <WhatsappIcon
                  size={38}
                  round
                />
              </a>
              <EmailShareButton
                className="mx-1"
                body={title + ' ' + url}
                url={url}
                // subject={novelty?.id ? data.headline : getFakeAddres(data)}
              >
                <EmailIcon
                  size={38}
                  round
                />
              </EmailShareButton>
              <FacebookMessengerShareButton
                className="mx-1"
                url={url}
                appId="521270401588372"
              >
                <FacebookMessengerIcon
                  size={38}
                  round
                />
              </FacebookMessengerShareButton>
              <TelegramShareButton
                className="mx-1"
                url={url}
                title={title}
              >
                <TelegramIcon
                  size={38}
                  round
                />
              </TelegramShareButton>
              <FacebookShareButton
                className="mx-1"
                url={url}
                quote={title}
              >
                <FacebookIcon
                  size={38}
                  round
                />
              </FacebookShareButton>
              <TwitterShareButton
                className="mx-1 icon-tw"
                url={url}
                title={title}
              >
                {/* <TwitterIcon
                  size={38}
                  round
                /> */}
                <i className={'icon-twitter circle-icon'} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={url}
                source={url}
                title={title}
                className="mx-1"
              >
                <LinkedinIcon
                  size={38}
                  round
                />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ''
  )
}

export default connect(() => ({}), null)(SocialModal)
